module.exports = "<div class=modal-header><h4 class=modal-title>We're experiencing a problem</h4></div><div class=\"modal-body bg-danger\"><p>We're experiencing a problem responding to your request. Please contact the online helpdesk</p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=$close()>Ok</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/main/templates/modals/serverErrorNotification.tmpl.html
// module id = 169
// module chunks = 0